// extracted by mini-css-extract-plugin
export default {"dot":"TypingDots_dot__ixV8e","bounce":"TypingDots_bounce__nKtwX"};